import React from 'react';
import Svg from '../Svg';

interface IReservation {
  fill?: string;
  color?: string;
  size?: string;
}

const Reservation: React.FC<IReservation> = ({ fill, color, size = '20px' }) => (
  <Svg
    fill={fill}
    color={color}
    size={size}
    path="M511.747,374.302l-39.385-242.905c-1.547-9.535-9.779-16.542-19.439-16.542H59.078c-9.658,0-17.892,7.007-19.439,16.542
    L0.254,374.302c-0.924,5.699,0.7,11.515,4.441,15.913c3.742,4.398,9.224,6.93,14.998,6.93h472.615
    c5.773,0,11.256-2.534,14.998-6.93C511.048,385.818,512.672,380.001,511.747,374.302z M42.835,357.762l16.341-100.784
    l16.341,100.784H42.835z M115.416,357.761v0.001L82.417,154.241h353.75l32.999,203.52H115.416z"
    path2="M393.847,236.309H157.539c-10.875,0-19.692,8.817-19.692,19.692c0,10.875,8.817,19.692,19.692,19.692h236.308
    c10.875,0,19.692-8.817,19.692-19.692C413.539,245.126,404.722,236.309,393.847,236.309z"
    viewBox="0 0 512.001 512.001"
  />
);

export default Reservation;
